import React from "react";

const FPUCurrentContent = () => {
  const currentMission = {
    name: "MINUSCA",
    fullName:
      "United Nations Multidimensional Integrated Stabilization Mission in the Central African Republic",
    location: "Republik Afrika Tengah",
    startDate: "2014",
    personnel: {
      polki: 120,
      polwan: 20,
      total: 140,
    },
    contingentName: "Garuda Bhayangkara",
    deploymentPeriod: "12 bulan",
  };

  const capabilities = [
    {
      name: "Keamanan dan Patroli",
      description:
        "Patroli keamanan di area misi dan perlindungan instalasi PBB",
      icon: "🚔",
    },
    {
      name: "Perlindungan Sipil",
      description: "Melindungi masyarakat sipil dari ancaman kekerasan",
      icon: "🛡️",
    },
    {
      name: "Pembinaan Kepolisian",
      description: "Membantu pembangunan kapasitas kepolisian lokal",
      icon: "👨‍🏫",
    },
    {
      name: "Penanganan Crowd Control",
      description: "Pengendalian massa dan situasi kerusuhan",
      icon: "⚡",
    },
    {
      name: "Operasi Khusus",
      description: "Dukungan operasi khusus dan investigasi",
      icon: "🎯",
    },
    {
      name: "Bantuan Kemanusiaan",
      description: "Mendukung distribusi bantuan kemanusiaan",
      icon: "❤️",
    },
  ];

  const achievements = [
    {
      title: "Zero Casualty Record",
      description: "Mempertahankan tingkat keselamatan 100% personel",
      icon: "🏆",
    },
    {
      title: "Community Engagement",
      description: "Program pemberdayaan masyarakat lokal",
      icon: "🤝",
    },
    {
      title: "Operational Excellence",
      description: "Pengakuan PBB atas kinerja operasional",
      icon: "⭐",
    },
    {
      title: "Professional Training",
      description: "Pelatihan berkelanjutan untuk personel lokal",
      icon: "📚",
    },
  ];

  return (
    <div className="p-8">
      <div className="space-y-8">
        {/* Current Mission Overview */}
        <div className="bg-gradient-to-r from-primary/20 to-secondary/20 rounded-xl p-6">
          <h2 className="text-2xl font-bold mb-6">
            Kontingen Garuda Bhayangkara - MINUSCA
          </h2>
          <div className="bg-base-100 rounded-lg p-6">
            <div className="flex items-center gap-4 mb-6">
              <div className="text-5xl">🇨🇫</div>
              <div className="flex-1">
                <h3 className="text-xl font-bold mb-2">
                  {currentMission.name}
                </h3>
                <p className="text-base-content/70 mb-2">
                  {currentMission.fullName}
                </p>
                <div className="flex flex-wrap gap-4 text-sm">
                  <span className="flex items-center gap-1">
                    <span className="text-base-content/50">📍</span>
                    {currentMission.location}
                  </span>
                  <span className="flex items-center gap-1">
                    <span className="text-base-content/50">📅</span>
                    Sejak {currentMission.startDate}
                  </span>
                  <span className="flex items-center gap-1">
                    <span className="text-base-content/50">⏱️</span>
                    {currentMission.deploymentPeriod} per rotasi
                  </span>
                </div>
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
              <div className="bg-primary/10 rounded-lg p-4 text-center border-2 border-primary/20">
                <div className="text-2xl mb-2">👨‍✈️</div>
                <h4 className="font-semibold">Polki</h4>
                <p className="text-primary font-bold text-xl">
                  {currentMission.personnel.polki}
                </p>
              </div>
              <div className="bg-secondary/10 rounded-lg p-4 text-center border-2 border-secondary/20">
                <div className="text-2xl mb-2">👩‍✈️</div>
                <h4 className="font-semibold">Polwan</h4>
                <p className="text-secondary font-bold text-xl">
                  {currentMission.personnel.polwan}
                </p>
              </div>
              <div className="bg-accent/10 rounded-lg p-4 text-center border-2 border-accent/20">
                <div className="text-2xl mb-2">👥</div>
                <h4 className="font-semibold">Total</h4>
                <p className="text-accent font-bold text-xl">
                  {currentMission.personnel.total}
                </p>
              </div>
              <div className="bg-success/10 rounded-lg p-4 text-center border-2 border-success/20">
                <div className="text-2xl mb-2">🦅</div>
                <h4 className="font-semibold">Kontingen</h4>
                <p className="text-success font-bold text-sm">
                  {currentMission.contingentName}
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Mission Capabilities */}
        <div className="bg-base-200 rounded-xl p-6">
          <h2 className="text-2xl font-bold mb-6">Kemampuan Operasional</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {capabilities.map((capability, index) => (
              <div key={index} className="bg-base-100 rounded-lg p-6">
                <div className="text-3xl mb-3 text-center">
                  {capability.icon}
                </div>
                <h3 className="font-semibold text-lg mb-3 text-center">
                  {capability.name}
                </h3>
                <p className="text-base-content/70 text-sm text-center leading-relaxed">
                  {capability.description}
                </p>
              </div>
            ))}
          </div>
        </div>

        {/* Mission Structure & Command */}
        <div className="bg-base-200 rounded-xl p-6">
          <h2 className="text-2xl font-bold mb-6">
            Struktur Komando dan Organisasi
          </h2>
          <div className="space-y-6">
            <div className="bg-base-100 rounded-lg p-6">
              <h3 className="font-semibold text-lg mb-4">
                Struktur Komando FPU
              </h3>
              <div className="space-y-4">
                <div className="flex items-center gap-4 p-4 bg-primary/10 rounded-lg">
                  <div className="text-2xl">👤</div>
                  <div>
                    <h4 className="font-semibold">Komandan FPU</h4>
                    <p className="text-sm text-base-content/70">
                      Perwira Tinggi Polri
                    </p>
                  </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-4 ml-8">
                  <div className="flex items-center gap-4 p-4 bg-secondary/10 rounded-lg">
                    <div className="text-xl">👥</div>
                    <div>
                      <h4 className="font-semibold">Wakil Komandan</h4>
                      <p className="text-sm text-base-content/70">
                        Deputy Commander
                      </p>
                    </div>
                  </div>

                  <div className="flex items-center gap-4 p-4 bg-accent/10 rounded-lg">
                    <div className="text-xl">📋</div>
                    <div>
                      <h4 className="font-semibold">Staff Operasi</h4>
                      <p className="text-sm text-base-content/70">
                        Operations Staff
                      </p>
                    </div>
                  </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-3 gap-4 ml-16">
                  <div className="flex items-center gap-3 p-3 bg-base-200 rounded-lg">
                    <div className="text-lg">🔥</div>
                    <div>
                      <h5 className="font-medium text-sm">Unit Alpha</h5>
                      <p className="text-xs text-base-content/70">
                        Team Operasi
                      </p>
                    </div>
                  </div>

                  <div className="flex items-center gap-3 p-3 bg-base-200 rounded-lg">
                    <div className="text-lg">🛡️</div>
                    <div>
                      <h5 className="font-medium text-sm">Unit Bravo</h5>
                      <p className="text-xs text-base-content/70">
                        Team Keamanan
                      </p>
                    </div>
                  </div>

                  <div className="flex items-center gap-3 p-3 bg-base-200 rounded-lg">
                    <div className="text-lg">🎯</div>
                    <div>
                      <h5 className="font-medium text-sm">Unit Charlie</h5>
                      <p className="text-xs text-base-content/70">Tim Khusus</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Current Achievements */}
        <div className="bg-base-200 rounded-xl p-6">
          <h2 className="text-2xl font-bold mb-6">Pencapaian Terkini</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {achievements.map((achievement, index) => (
              <div key={index} className="bg-base-100 rounded-lg p-6">
                <div className="flex items-start gap-4">
                  <div className="text-3xl">{achievement.icon}</div>
                  <div className="flex-1">
                    <h3 className="font-semibold text-lg mb-2">
                      {achievement.title}
                    </h3>
                    <p className="text-base-content/70 leading-relaxed">
                      {achievement.description}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Operational Status */}
        <div className="bg-base-200 rounded-xl p-6">
          <h2 className="text-2xl font-bold mb-6">
            Status Operasional Terkini
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            <div className="bg-success/10 rounded-lg p-6 text-center border-2 border-success/20">
              <div className="text-3xl mb-3">✅</div>
              <h3 className="font-semibold text-lg mb-2">Siap Operasi</h3>
              <p className="text-success font-bold text-2xl">100%</p>
              <p className="text-sm text-base-content/70 mt-1">
                Kesiapan Personel
              </p>
            </div>

            <div className="bg-primary/10 rounded-lg p-6 text-center border-2 border-primary/20">
              <div className="text-3xl mb-3">🛡️</div>
              <h3 className="font-semibold text-lg mb-2">Keamanan Area</h3>
              <p className="text-primary font-bold text-2xl">Stabil</p>
              <p className="text-sm text-base-content/70 mt-1">
                Situasi Terkendali
              </p>
            </div>

            <div className="bg-secondary/10 rounded-lg p-6 text-center border-2 border-secondary/20">
              <div className="text-3xl mb-3">🎯</div>
              <h3 className="font-semibold text-lg mb-2">Misi Progress</h3>
              <p className="text-secondary font-bold text-2xl">Lancar</p>
              <p className="text-sm text-base-content/70 mt-1">Sesuai Target</p>
            </div>
          </div>
        </div>

        {/* Preparation & Training */}
        <div className="bg-base-200 rounded-xl p-6">
          <h2 className="text-2xl font-bold mb-6">Persiapan dan Pelatihan</h2>
          <div className="bg-base-100 rounded-lg p-6">
            <p className="leading-relaxed text-base-content/70 mb-6">
              Sebelum penugasan, seluruh personel FPU menjalani persiapan
              intensif yang mencakup pelatihan fisik, mental, teknik, dan
              pengetahuan tentang budaya lokal daerah misi.
            </p>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div>
                <h3 className="font-semibold text-lg mb-4">
                  Program Pelatihan
                </h3>
                <ul className="space-y-2">
                  <li className="flex items-center gap-2">
                    <span className="text-primary">•</span>
                    <span>Pelatihan Peacekeeping Operations</span>
                  </li>
                  <li className="flex items-center gap-2">
                    <span className="text-primary">•</span>
                    <span>Bahasa Inggris dan Perancis</span>
                  </li>
                  <li className="flex items-center gap-2">
                    <span className="text-primary">•</span>
                    <span>Cultural Awareness Afrika Tengah</span>
                  </li>
                  <li className="flex items-center gap-2">
                    <span className="text-primary">•</span>
                    <span>First Aid dan Medical Training</span>
                  </li>
                  <li className="flex items-center gap-2">
                    <span className="text-primary">•</span>
                    <span>Conflict Resolution</span>
                  </li>
                </ul>
              </div>

              <div>
                <h3 className="font-semibold text-lg mb-4">Sertifikasi</h3>
                <ul className="space-y-2">
                  <li className="flex items-center gap-2">
                    <span className="text-secondary">•</span>
                    <span>UN Peacekeeping Certificate</span>
                  </li>
                  <li className="flex items-center gap-2">
                    <span className="text-secondary">•</span>
                    <span>DPKO Training Standards</span>
                  </li>
                  <li className="flex items-center gap-2">
                    <span className="text-secondary">•</span>
                    <span>Mission-Specific Qualification</span>
                  </li>
                  <li className="flex items-center gap-2">
                    <span className="text-secondary">•</span>
                    <span>Human Rights Certification</span>
                  </li>
                  <li className="flex items-center gap-2">
                    <span className="text-secondary">•</span>
                    <span>Gender Awareness Training</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        {/* Future Rotations */}
        <div className="bg-gradient-to-r from-accent/20 to-success/20 rounded-xl p-6">
          <h2 className="text-2xl font-bold mb-6">Rencana Rotasi Mendatang</h2>
          <div className="bg-base-100 rounded-lg p-6">
            <p className="leading-relaxed text-base-content/70 mb-4">
              Polri berkomitmen untuk terus mengirimkan FPU berkualitas tinggi
              dalam rotasi berkelanjutan guna mendukung stabilitas dan
              perdamaian di Afrika Tengah.
            </p>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
              <div className="text-center">
                <div className="text-2xl mb-2">🔄</div>
                <h4 className="font-semibold">Rotasi Rutin</h4>
                <p className="text-sm text-base-content/70">Setiap 12 bulan</p>
              </div>
              <div className="text-center">
                <div className="text-2xl mb-2">📈</div>
                <h4 className="font-semibold">Peningkatan Kualitas</h4>
                <p className="text-sm text-base-content/70">
                  Training berkelanjutan
                </p>
              </div>
              <div className="text-center">
                <div className="text-2xl mb-2">🌍</div>
                <h4 className="font-semibold">Ekspansi Misi</h4>
                <p className="text-sm text-base-content/70">
                  Peluang misi baru
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FPUCurrentContent;
